export const NICEPAY_CLIENT_ID = 'R2_8bc8312830a846528b12d913571c6c88';
export const PHOTO_PAYMENT_APPROVE_BASE_URL =
  'https://wfw8chmuu9.execute-api.ap-northeast-2.amazonaws.com/prod/photo-payment-approve';

export function generateOrderId() {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const h = date.getHours().toString().padStart(2, '0');
  const m = date.getMinutes().toString().padStart(2, '0');
  const s = date.getSeconds().toString().padStart(2, '0');
  const rand = Math.random().toString(36).substring(2, 8);
  return `ORDER-${year}${month}${day}-${h}${m}${s}-${rand}`;
}

export function buildPhotoPaymentReturnUrl({ redirectPath, origin, payload, popup = false }) {
  const cognitoSub = payload?.cognitoSub || '';
  const base =
    `${PHOTO_PAYMENT_APPROVE_BASE_URL}` +
    `?redirect=${encodeURIComponent(redirectPath)}` +
    `&origin=${encodeURIComponent(origin)}` +
    (cognitoSub ? `&cognitoSub=${encodeURIComponent(cognitoSub)}` : '') +
    `&payload=${encodeURIComponent(JSON.stringify(payload))}`;
  return popup ? `${base}&popup=true` : base;
}

export function createNicePayPaymentStartHtml(paymentConfig) {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>결제 중...</title>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <script src="https://pay.nicepay.co.kr/v1/js/"></script>
      <script src="https://nsp.pay.naver.com/sdk/js/naverpay.min.js"></script>
    </head>
    <body>
      <div style="text-align:center; padding:50px;">
        <p>결제를 진행하고 있습니다...</p>
      </div>
      <script>
        (function() {
          const cfg = ${JSON.stringify(paymentConfig).replace(/</g, '\\u003c')};
          const clientId = cfg.clientId;
          const method = cfg.method;
          const orderId = cfg.orderId;
          const amount = parseInt(cfg.amount, 10);
          const goodsName = cfg.goodsName;
          const returnUrl = cfg.returnUrl;
          const origin = cfg.origin;

          function startPay(attempt) {
            if (window.AUTHNICE) {
              window.AUTHNICE.requestPay({
                clientId: clientId,
                method: method,
                orderId: orderId,
                amount: amount,
                goodsName: goodsName,
                returnUrl: returnUrl,
                fnError: function (result) {
                  if (window.opener) {
                    window.opener.postMessage({
                      type: 'NICEPAY_PAYMENT_FAIL',
                      message: (result && result.errorMsg) ? result.errorMsg : '결제 중 오류가 발생했습니다.'
                    }, origin);
                  }
                  alert((result && result.errorMsg) ? result.errorMsg : '결제 중 오류가 발생했습니다.');
                  if (window.opener) window.close();
                },
              });
              return;
            }
            if (attempt >= 30) {
              alert('결제 스크립트를 불러올 수 없습니다. 잠시 후 다시 시도해주세요.');
              if (window.opener) {
                window.opener.postMessage({
                  type: 'NICEPAY_PAYMENT_FAIL',
                  message: '결제 스크립트를 불러올 수 없습니다.'
                }, origin);
                window.close();
              }
              return;
            }
            setTimeout(function() { startPay(attempt + 1); }, 100);
          }

          startPay(0);
        })();
      </script>
    </body>
    </html>
  `;
}

export function openCenteredPopup(url, { name = 'popup', width = 500, height = 700 } = {}) {
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;
  return window.open(
    url,
    name,
    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
  );
}

export function openNicePayPopupFromHtml(html, { name = 'payment', width = 500, height = 700 } = {}) {
  const blob = new Blob([html], { type: 'text/html' });
  const popupUrl = URL.createObjectURL(blob);
  return openCenteredPopup(popupUrl, { name, width, height });
}


